module.exports = __webpack_public_path__ + "img/R7.978aa73e.png";